import $ from 'jquery';
import '@mockup/func/globals/App.util';
import { App } from './App';

export const pagedtable = {
    init: function () {
        $.ajaxSetup({ cache: false });
        this.events('.js-paged-table-component');
    },
    events: function (elm) {
        $(elm).on('click.pagedtable', '.pagedList a[href]:not(.pagedtable-company-letter):not(.pagedtable-company-payment):not(.pagedtable-company):not(.pagedtable-member):not(.pagedtable-member-payment)', function () {
            var $a = $(this);
            $.ajax({
                url: $a.attr('href'),
                type: 'get'
            }).done(function (data) {
                var target = $a.closest('.ippagedtable').find('div[data-ippagedtable-target]').parents('.js-paged-table-component');
                $(target).replaceWith(data);
                pagedtable.offEvents('.js-paged-table-component');
                pagedtable.events('.js-paged-table-component');

                $(document).trigger('pagedtable.ajax.done');
            });

            return false;
        });

        $(elm).on('change.pagedtable', '.pageListDropdown', function () {
            var $l = $(this);

            $.ajax({
                url: $l.find(':selected').val(),
                type: 'get'
            }).done(function (data) {
                var target = $l.closest('.ippagedtable').find('div[data-ippagedtable-target]').parents('.js-paged-table-component');
                $(target).replaceWith(data);
                pagedtable.offEvents('.js-paged-table-component');
                pagedtable.events('.js-paged-table-component');

                $(document).trigger('pagedtable.ajax.done');
            });

            return false;
        });

        if ($(elm).find('.pagedtable-member').length) {
            $(elm).on('click.pagedtable-member', '.pagedtable-member', function (e) {
                if ($(this).hasClass('lightbox-iframe')) {
                    e.stopImmediatePropagation();
                    return false;
                }

                return true;
            });
        }

        if ($(elm).find('.pagedtable-member-payment').length) {
            $(elm).on('click.pagedtable-member-payment', '.pagedtable-member-payment', function (e) {

                e.stopImmediatePropagation();
                const elm = $(this);
                const referenceId = $(elm).parent().data('referenceid');
                const produktnavn = $(elm).parent().data('produktnavn');
                window.StartNetaxeptTransaction(referenceId, '', null);
                var target = $(this).closest('.ippagedtable').find('div[data-ippagedtable-target]').parents('.js-paged-table-component');
                ga('send', 'event', 'Login', 'Betalinger_Medlem', 'betaling_knap');

                return false;

            });
        }

        if ($(elm).find('.link.pagedtable-company').length) {
            $(elm).on('click.pagedtable-company', '.link.pagedtable-company', function (e) {
                if ($(this).hasClass('lightbox-iframe')) {
                    e.stopImmediatePropagation();
                    return false;
                }

                return true;
            });
        }

        if ($(elm).find('.link.pagedtable-company-payment').length) {
            $(elm).on('click.pagedtable-company-payment', '.link.pagedtable-company-payment', function (e) {

                e.stopImmediatePropagation();
                pagedtable.setUpFancyBox($(this));
                var target = $(this).closest('.ippagedtable').find('div[data-ippagedtable-target]').parents('.js-paged-table-component');
                $(target).find('#uiDiv_PTDibsCom').trigger('click');
                if (typeof window.ga === 'function') {
                    window.ga('send', 'event', 'Login', 'Betalinger_Virksomhed', 'betaling_knap');
                }

                return false;
            });
        }

        if ($(elm).find('.pagedtable-company-letter').length) {
            $(elm).on('click.pagedtable-company-letter', '.pagedtable-company-letter', function (e) {
                $(this).find('strong').contents().unwrap();
                var ua = window.navigator.userAgent;
                var msie = ua.indexOf('MSIE ');
                if (typeof window.ga === 'function') {
                    window.ga('send', 'event', 'Login', 'VoresBreve_Virksomhed', 'dokument_link_clicked');
                }
                if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./)) {
                    e.stopImmediatePropagation();
                    window.open($(this).parent().data('dibsurl'));
                    return true;
                }
                e.stopImmediatePropagation();
                pagedtable.setUpFancyBoxForLetter($(this));
                var target = $(this).closest('.ippagedtable').find('div[data-ippagedtable-target]').parents('.js-paged-table-component');
                $(target).find('#uiDiv_PTDibsCom').trigger('click');
                return false;
            });
            $(elm).on('click.js-pagedtable-company-letter-attachment', '.js-pagedtable-company-letter-attachment', function (e) {

                $(this).find('strong').contents().unwrap();
                var ua = window.navigator.userAgent;
                var msie = ua.indexOf('MSIE ');
                if (typeof window.ga === 'function') {
                    window.ga('send', 'event', 'Login', 'VoresBreve_Virksomhed', 'attachment_link_clicked');
                }
                if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv:11\./)) {
                    e.stopImmediatePropagation();
                    window.open($(this).parent().data('dibsurl'));
                    return true;
                }
                e.stopImmediatePropagation();
                pagedtable.setUpFancyBoxForLetterAttachment($(this));
                var target = $(this).closest('.ippagedtable').find('div[data-ippagedtable-target]').parents('.js-paged-table-component');
                $(target).find('#uiDiv_PTDibsCom').trigger('click');
                return false;
            });
        }
    },
    setUpFancyBox: function (elm) {
        var scrol = isMobileDevice ? 'auto' : 'no';
        var referenceId = $(elm).parent().data('referenceid');
        var dibsUrl = $(elm).parent().data('dibsurl');
        var produktnavn = $(elm).parent().data('produktnavn');

        $.fancybox.open({
            type: 'ajax',
            href: dibsUrl,
            ajax: {
                type: 'POST',
                data: {
                    encrytptedReferenceId: referenceId,
                    produktnavn: produktnavn
                }
            },
            scrolling: scrol,
            padding: 15,
            margin: 20
        });
    },
    setUpFancyBoxForLetter: function (elm) {
        var referenceId = $(elm).parent().data('referenceid');
        var dibsUrl = $(elm).parent().data('dibsurl');
        var produktnavn = $(elm).parent().data('produktnavn');

        $.fancybox.open({
            type: 'iframe',
            href: dibsUrl,
            ajax: {
                type: 'POST',
                data: {
                    encrytptedReferenceId: referenceId,
                    produktnavn: produktnavn
                }
            },
            frame: {
                scrolling: 'auto',
                preload: true
            },
            width: '75%',
            height: '95%',
            padding: 10,
            autoSize: false
        });
    },
    setUpFancyBoxForLetterAttachment: function (elm) {
        var attachmentUrl = $(elm).data('attachmenturl');

        $.fancybox.open({
            type: 'iframe',
            href: attachmentUrl,
            ajax: {
                type: 'POST'
            },
            frame: {
                scrolling: 'auto',
                preload: true
            },
            width: '75%',
            height: '95%',
            padding: 10,
            autoSize: false
        });
    },
    offEvents: function (elm) {
        $(elm).off('click.pagedtable');
        $(elm).off('change.pagedtable');
        $(elm).off('click.pagedtable-member');
        $(elm).off('click.pagedtable-company');
        $(elm).off('click.pagedtable-company-payment');
        $(elm).off('click.pagedtable-company-letter');
        $(elm).off('click.pagedtable-member-payment');
    }
};

export default pagedtable;

App.Util.pagedtable = pagedtable;
